import { render, staticRenderFns } from "./QuoteGenButton.vue?vue&type=template&id=22a8722a&scoped=true"
import script from "./QuoteGenButton.vue?vue&type=script&lang=js"
export * from "./QuoteGenButton.vue?vue&type=script&lang=js"
import style0 from "./QuoteGenButton.vue?vue&type=style&index=0&id=22a8722a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a8722a",
  null
  
)

export default component.exports